module.exports = __webpack_public_path__ + "static/img/메달-지리영토.3a86f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/메달-지리영토.png
// module id = h2kD
// module chunks = 0